import Nullstack from 'nullstack';
export default function IconDeviceTvOld({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-device-tv-old",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "7",
    width: "18",
    height: "13",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M16 3l-4 4l-4 -4"
  }), "   ", Nullstack.element("path", {
    d: "M15 7v13"
  }), "   ", Nullstack.element("path", {
    d: "M18 15v.01"
  }), "   ", Nullstack.element("path", {
    d: "M18 12v.01"
  }), " ");
}